import React, { useEffect, useState } from 'react'

import Tooltip from '../../govwell-ui/components/Tooltip'

const BufferPx = 1 // Font & layout quirks can cause single lines of text to have higher scroll heights than their client height, even in the absence of a scroll bar

type Props = {
  isEnabled: boolean
  originalTextChildren: React.ReactNode
  childrenRef: React.RefObject<HTMLElement>
  children: React.ReactNode
}
const AutomaticTruncationTooltip = ({
  isEnabled,
  originalTextChildren,
  childrenRef,
  children,
}: Props) => {
  const [title, setTitle] = useState<React.ReactNode>('')
  useEffect(() => {
    const el = childrenRef.current
    if (!el || !isEnabled) {
      return
    }

    const listener = (e: MouseEvent) => {
      const target = e.currentTarget as HTMLElement
      if (
        target.scrollWidth > target.clientWidth + BufferPx ||
        target.scrollHeight > target.clientHeight + BufferPx
      ) {
        setTitle(originalTextChildren)
      } else {
        setTitle('')
      }
    }
    el.addEventListener('mouseenter', listener)
    return () => el.removeEventListener('mouseenter', listener)
  }, [childrenRef, isEnabled, originalTextChildren])

  if (isEnabled) {
    return (
      <Tooltip content={title}>
        <span>{children}</span>
      </Tooltip>
    )
  }

  return <React.Fragment>{children}</React.Fragment>
}

export default React.memo(AutomaticTruncationTooltip)
